var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-login-page"},[_c('zj-startup',{attrs:{"percent":_vm.startup.percent,"msg":_vm.startup.msg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }